<style type="text/css">
  .absolute-divs {
  margin: 0;
  padding: 0;
  z-index: 2;
  position: absolute;
  transform:translate(-50%, 0);
  width: 71.2%;
  left: 50%;
}
.controls-container {
height: 5.7%;
bottom: 10.86%;
-webkit-transition: opacity 300ms ease-in-out;
-moz-transition: opacity 300ms ease-in-out;
-o-transition: opacity 300ms ease-in-out;
transition: opacity 300ms ease-in-out;
}
/*@media screen and (max-width: 500px) {
div{width:70%;}
}
@media screen and (max-device-width: 800px) {
html { background: url(/assets/img/polina.jpg) #000 no-repeat center center fixed; }
#bgvid { display: none; }
}*/
.svg-bg {
width: auto;
height: auto;
z-index: 2;
background-size: contain;
background-repeat: no-repeat;
transition: 200ms;
transition-timing-function: ease-in-out;
-webkit-transition: 200ms;
-webkit-transition-timing-function: ease-in-out;
cursor: pointer;
display: block;
margin: 0 auto;
}
.svg-bg.play {
background-image: url('/assets/img/play.svg');
}
.svg-bg.play:hover {
background-image: url('/assets/img/play-color.svg');
}
.svg-bg.pause {
background-image: url('/assets/img/pause.svg');
}
.svg-bg.pause:hover {
background-image: url('/assets/img/pause-color.svg');
}
.controls-group, .time-group {
float: left;
}
.controls-group {
width: 70%;
}
.time-group {
width: 30%;
}
.controls-group button.svg-bg {
height: 24px;
width: 24px;
float: left;
margin-right: 40px;
}
.time-group div {
float: right;
}
.time-group .current, .time-group .max, .time-group .separator{
font-family: "Campton-book";
line-height: 1.33;
letter-spacing: 1.8px;
opacity: 0.5;
}
.time-group .current {
opacity: 1;
font-weight: bold;
}
.time-group .separator {
line-height: 1;
margin: 0 8px;
font-size: 1.33rem;
}
.progress-group {
bottom: 0;
height: 4px;
width: 100%;
background-color: transparent;
position: absolute;
}
.progress-group .played {
width: 0%;
opacity: 1;
height: 4px;
background-color: #ffffff;
float: left;
}
.progress-group .unplayed {
width: 100%;
height: 4px;
opacity: .4;
background-color: #ffffff;
float: left;
}
.progress-group .current {
width: 4px;
opacity: 1;
height: 14px;
background-color: #ffffff;
float: left;
position: absolute;
left: 0%;
top: -5px;
}
</style>
<div class="absolute-divs controls-container">
  <div class="controls-group">
    @if (!underPlay) {
      <button aria-label="Play" type="button" class="btn btn-link svg-bg play" (click)="onPlay()"></button>
    }
    @if (underPlay) {
      <button aria-label="Pause" type="button" class="btn btn-link svg-bg pause" (click)="onPause()"></button>
    }
  </div>
  <div class="time-group">
    <div class="max">{{ duration | secondsToTime }}</div>
    <div class="separator">|</div>
    <div class="current">{{ currentTime | secondsToTime }}</div>
  </div>
  <div class="clearfix"></div>
  <div class="progress-group">
    <div class="played" [ngStyle]="{width: progressValue + '%'}"></div>
    <div class="current" [ngStyle]="{left: progressValue + '%'}"></div>
    <div class="unplayed" [ngStyle]="{width: (100 - progressValue) + '%'}"></div>
  </div>
</div>
